import React, { useEffect, useState } from 'react'
import '../css/Announcements.css'
import axios from '../axios'
const Announcements = () => {
  const[toggle, setToggle] = useState(false)
  const[code, setCode] = useState(false)
  const[title, setTitle] = useState(' ')
  const[content, setContent] = useState(' ')
  const[password, setPassword] = useState('')
  const[posts, setPosts] = useState([])
  const getPosts = async() => {
   const res = await axios.get('/announcements')
   let p = res.data
   let newArr = []
   let c = 0
   p.reverse()
   p.map(x => {
      c+=1
      const b = {
        _id: x._id,
        title: x.title,
        text: x.text,
         count: c
      }
      newArr.push(b)
   })
   setPosts(newArr)
  }
  useEffect(() => {
     getPosts()
  },[])
  return (
    <div className="announcementContainer">
        <div className="createAnnouncement">
            {toggle ? (
                <>
                {code ? (
                  <div className='avgCol'>
                        <input onChange={(e) => {
                          setTitle(e.target.value)
                        }} className="normalInput" placeholder="Title"/>
                        <br/>
                        <input onChange={(e) => {
                            setContent(e.target.value)
}} className="normalInput" placeholder="Content"/>
                        <button onClick={() => {
                            const d = new Date()
                            axios.post('/post/announcements', {
                                title: title,
                                text: content
                            })
                            setCode(false)
                            setToggle(false)
                            alert("Post Uploaded.")
                        }} className="subBtn">Create Post</button>
                  </div>
                ) : (
                <div className="avgCol">
                    <input type="password" onChange={(e) => {
                        setPassword(e.target.value)
                    }} className="normalInput" placeholder="Code..."/>
                    <button onClick={()=>{
                        axios.get(`/authcode?password=${password}`).then(res => {
                            setCode(res.data)
                            if (!res.data) {
                                alert("Code Invailid")
                            }
                        })
                    }}className="subBtn">Submit</button>
                </div>
                )}
                </>
            ) : (
               <button onClick={() => {
                  setToggle(!toggle)
               }}>Create Announcement</button>
            )}
        </div>
        <div className="postArea">
          {posts.length <= 0 ? (
             <p>Loading....</p>
          ) : ( 
            <>
            {posts.map(post => {
         return (
           <div className="postCard" key={post._id}>
            <div className="innerPost">
              <h3>#{post.count} {post.title}</h3>
              <p>{post.text}</p>
            </div>
           </div>
         )
       })}
         </>
           
          )}
        </div>
    </div>
  )
}

export default Announcements